import { unseal } from '@/api/encryption'
const host = document.domain
const url = document.URL
let user = localStorage.getItem('user');

const installRouter = (router) => {
// 部分平台要求域名访问后直接跳转外网门户页
router.beforeEach((to, from, next) => {
  if (host === 'xm.sszx.cn' && to.name === 'login' && !user) {
    router.push({
      path: '/website/a02b37fd491b423ea1dcd4615a1adbc2'
    })
  } else if (host === 'zc.qzedu.cn' && to.name === 'login' && !user) {
    router.push({
      path: '/website/1d91479b32a4b30097891c8369b7b1cc'
    })
  } else if (host === 'itayz.xmedu.cn' && to.name === 'login' && !user) {
    router.push({
      path: '/website/c84719fbadf308ba3372d26d1e2b2313'
    })
  } else if (host === 'zhxy.jjyz.net' && to.name === 'login' && !user) {
    router.push({
      path: '/website/1d91479b32a4b30097891c8369b7b1cc'
    })
  } else if (host === 'ldm.fzgledu.cn' && to.name === 'login' && !user) {
    router.push({
      path: '/website/1d91479b32a4b30097891c8369b7b1cc'
    })
  } else if (host === 'www.xmjmedu.com' && to.name === 'login' && !user) {
    router.push({
      path: '/website/1d91479b32a4b30097891c8369b7b1cc'
    })
  } else if (host === 'www.xmycxx.com' && to.name === 'login' && !user) {
    router.push({
      path: '/website/1d91479b32a4b30097891c8369b7b1cc'
    })
  } else if (host === 'wskjzs.longyanedu.net' && to.name === 'login' && !user && !url.includes('website')) {
    window.location.replace('https://www.longyanedu.net/space/index.php?r=portal/user/login')
    return;
  } else if (host === 'zhxy.xmxdzx.com' && to.name === 'login' && !user) {
    router.push({
      path: '/website/68513b51cc9e77f385b4c5c7b3998eab'
    })
  }
  // if (to.query.customDeskId && to.path === '/customInstrument') {
  //   next('/error')
  //   return
  // }
  if (to.query.p && to.query.h && to.path === '/customInstrument') {
    const decoded = unseal(to.query)
    if (decoded) {
      // 解密成功，把数据还原回 query，并清除密文标记
      Object.assign(to.query, decoded);
      delete to.query.p;
      delete to.query.h;
      next();
    } else {
      next('/error'); // 篡改直接拦截
    }
  } else {
    next();
  }
});
}

export default installRouter;